export const config = {
  HOST: 'https://api.conexize.com', 
}
